import React, {
	ChangeEvent,
	Dispatch,
	useCallback,
	useEffect,
	useState,
} from "react";
import { TextInput, Select } from "@alm/flow-ds/components";
import { Actions, createFilter, setQueryFilter } from "./finderReducer";
import { operators, TextInputElementDefinition } from "lib/api/types";
import { useTranslation } from "react-i18next";
import jsonpointer from "lib/jsonpointer/jsonpointer";

type Props = TextInputElementDefinition & {
	index: number;
	dispatch: Dispatch<Actions>;
	queryValue?: string;
};

type Operators = operators.contains | operators.exact;

function TextSearchField({ index, label, id, dispatch, queryValue }: Props) {
	const { t } = useTranslation();
	const [value, setValue] = useState(
		queryValue !== undefined ? queryValue : ""
	);
	const [operator, setOperator] = useState<Operators>(operators.contains);

	const onValueChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			setValue(event.currentTarget.value);
		},
		[]
	);

	const onOperatorChange = useCallback(
		(event: ChangeEvent<HTMLSelectElement>) => {
			setOperator(event.currentTarget.value as Operators);
		},
		[]
	);

	useEffect(() => {
		dispatch(
			setQueryFilter(
				createFilter(jsonpointer.pointerToId(id), operator, { value }),
				index,
				value || ""
			)
		);
	}, [dispatch, index, id, operator, value]);

	return (
		<>
			<div className="col-6 col-md-2">
				<Select
					label={t("elements.finder.selectOperatorLabel")}
					labelHidden={true}
					value={operator}
					onChange={onOperatorChange}>
					<option value="contains">
						{t("elements.finder.contains")}
					</option>
					<option value="exact">{t("elements.finder.exact")}</option>
				</Select>
			</div>
			<div className="col-12 col-md-5 col-lg-6 col-xl-4 mt-3 mt-md-0">
				<TextInput
					label={t("elements.finder.searchInputLabel", {
						label,
					})}
					onChange={onValueChange}
					labelHidden={true}
					id={`qbf-input-${index}`}
					value={value}
				/>
			</div>
		</>
	);
}

export default TextSearchField;
